/* ============================================================
   B-Pets product card · chip de entrega dinámico
   Cambia el texto del chip según hora local de Santiago:
   - Lun-vie hasta 13:59  → "Llega gratis hoy · Santiago"
   - Lun-vie desde 14:00  → "Llega gratis mañana · Santiago"
   - Sábado hasta 13:59   → "Llega gratis hoy · Santiago"
   - Sábado desde 14:00   → "Llega gratis el lunes · Santiago"
   - Domingo              → "Llega gratis mañana · Santiago"
   ============================================================ */
 
(function () {
  function getShippingText(isFree) {
    var freePart = isFree ? '<span class="bpets-card__shipping-emphasis">gratis</span> ' : '';
    var locationPart = '<span class="bpets-card__shipping-location"> · <span class="bpets-card__shipping-location-long">Santiago</span><span class="bpets-card__shipping-location-short">Stgo</span></span>';
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Santiago',
        hour: 'numeric',
        hour12: false,
        weekday: 'short'
      });
      var parts = fmt.formatToParts(new Date());
      var hourPart = parts.find(function (p) { return p.type === 'hour'; });
      var weekdayPart = parts.find(function (p) { return p.type === 'weekday'; });
      if (!hourPart || !weekdayPart) return 'Llega ' + freePart + 'hoy' + locationPart;
 
      var hour = parseInt(hourPart.value, 10);
      // Intl puede devolver "24" como "0" en formato 24h; normalizamos
      if (isNaN(hour)) hour = 0;
 
      var weekday = weekdayPart.value;
 
      if (weekday === 'Sun') return 'Llega ' + freePart + 'mañana' + locationPart;
      if (weekday === 'Sat') return hour < 14 ? 'Llega ' + freePart + 'hoy' + locationPart : 'Llega ' + freePart + 'el lunes' + locationPart;
      return hour < 14 ? 'Llega ' + freePart + 'hoy' + locationPart : 'Llega ' + freePart + 'mañana' + locationPart;
    } catch (e) {
      return 'Llega ' + freePart + 'hoy' + locationPart;
    }
  }
 
  function update(scope) {
    var root = scope || document;
    var chips = root.querySelectorAll('[data-bpets-shipping-chip]');
    chips.forEach(function (chip) {
      var isFree = chip.dataset.bpetsFree !== 'false';
      var textEl = chip.querySelector('[data-bpets-shipping-text]');
      if (textEl) {
        textEl.innerHTML = getShippingText(isFree);
      }
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { update(); });
  } else {
    update();
  }
 
  // Re-aplica al cambiar de sección en el customizer o tras AJAX filters
  document.addEventListener('shopify:section:load', function (e) {
    update(e.target);
  });
 
  // Algunos temas disparan este evento al filtrar/paginar colecciones
  document.addEventListener('shopify:section:reorder', function (e) {
    update(e.target);
  });
})();
 
/* ============================================================
   B-Pets product card · carrusel de imágenes con navegación
   Flechas + dots aparecen al hover; click para cambiar imagen.
   ============================================================ */
(function () {
  function initCarousel(card) {
    if (card.dataset.bpetsCarouselInit === 'true') return;
 
    // En mobile no inicializamos el carrusel: las imágenes secundarias están
    // ocultas vía CSS y la navegación con dedos sería awkward sin swipe nativo.
    if (window.matchMedia('(max-width: 767px)').matches) return;
 
    var slides = card.querySelectorAll('[data-bpets-slide]');
    if (slides.length < 2) return;
 
    var dots = card.querySelectorAll('[data-bpets-dot]');
    var prevBtn = card.querySelector('[data-bpets-prev]');
    var nextBtn = card.querySelector('[data-bpets-next]');
 
    var currentIndex = 0;
    var total = slides.length;
 
    function setActive(idx) {
      slides.forEach(function (slide, i) {
        if (i === idx) {
          slide.classList.add('is-active');
          slide.removeAttribute('aria-hidden');
        } else {
          slide.classList.remove('is-active');
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
      currentIndex = idx;
    }
 
    function stopEvent(e) {
      e.preventDefault();
      e.stopPropagation();
    }
 
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        stopEvent(e);
        var next = currentIndex === 0 ? total - 1 : currentIndex - 1;
        setActive(next);
      });
    }
 
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        stopEvent(e);
        var next = (currentIndex + 1) % total;
        setActive(next);
      });
    }
 
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        stopEvent(e);
        setActive(i);
      });
    });
 
    card.dataset.bpetsCarouselInit = 'true';
  }
 
  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('.bpets-card').forEach(initCarousel);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
 
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
 